<template>
  <div class="events">
    <span v-if="hasEvents">
      <span :style="styleHeader(endpoint)"> {{ endpoint.label }} </span>
      <v-btn
        small
        color="green"
        @click="resolveAllEvents(endpoint.id)"
      >
        Alle Fehler beheben
      </v-btn>
      <br><br>
      <v-list three-line>
        <template v-for="(item, index) in endpoint.events">
          <v-list-tile
            :key="`${JSON.stringify(item.message)}-${index}`"
            avatar
            ripple
            :style="backgroundEvent(endpoint, item)"
            :class="{'is-unresolved': !item.resolved}"
            @click="resolveEvent(item, index)"
          >

            <v-list-tile-content>
              <v-list-tile-title>Messwert: {{ item.type }}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">
                {{ item.message }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span v-if="item.resolved">GELÖST</span>
                <span v-else>UNGELÖST</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>
                {{ $moment(item.inserted_at).format('DD.MM.YYYY HH:mm:ss') }}
              </v-list-tile-action-text>
              <v-icon
                v-if="!item.resolved"
                color="grey lighten-1"
              >
                check_box_outline_blank
              </v-icon>

              <v-icon
                v-else
                color="green darken-2"
              >
                check_box
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Events',
  props: {
    endpoint: {
      type: Object,
      default() {
        return {};
      },
    },
    endpointId: {
      type: Number,
      default: null,
    },
    parentEndpoint: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showEvents: true,
    };
  },
  computed: {
    hasEvents() {
      if (this.endpoint.events.length) {
        return true;
      }
      return false;
    },
  },
  methods: {
    styleHeader() {
      return {
        padding: '10px',
        color: '#000',
        fontSize: '20px',
      };
    },
    backgroundEvent(endpoint, item) {
      if (!item.resolved) {
        return {
          border: '2px solid red',
          backgroundColor: 'red',
          padding: '5px',
          color: '#FFF',
          borderRadius: '15px',
          marginBottom: '8px',
          opacity: '0.8',
        };
      }
      return {
        border: `2px solid ${endpoint.color_code}`,
        padding: '5px',
        color: '#FFF',
        borderRadius: '15px',
        marginBottom: '8px',
        opacity: '0.9',
      };
    },
    resolveEvent(event) {
      // eslint-disable-next-line
      const confirm = window.confirm('Wurde die Störung wirklich behoben?');
      if (confirm) {
        this.showEvents = false;
        this.$store.dispatch('RESOLVE_EVENT_BY_ID', event)
          .then(() => {
            this.$store.state.gridAreas.endpointDetail = null;
            this.$store.dispatch('GET_ENDPOINT_DETAILS_BY_ID', this.parentEndpoint);
            this.showEvents = true;
            this.tab = 1;
            // @TODO: REFACTOR ..
            this.$store.dispatch('GET_ALL_GRID_AREAS', true);
          });
      }
    },
    resolveAllEvents(endpointId) {
      this.$store.dispatch('RESOLVE_ALL_EVENTS_BY_ENDPOINT', endpointId)
        .then(() => {
          this.$store.state.gridAreas.endpointDetail = null;
          this.$store.dispatch('GET_ENDPOINT_DETAILS_BY_ID', this.parentEndpoint);
          this.showEvents = true;
          this.tab = 1;
          // @TODO: REFACTOR ..
          this.$store.dispatch('GET_ALL_GRID_AREAS', true);
        });
    },
  },
};
</script>

<style scoped>
.events {
  padding: 10px;
  margin: 5px;
}
.heading {
  background: rgba(0, 0, 0, 0.2);
  padding: 10px;
  opacity: 0.9;
}
</style>
